export const onlyDigits = (value = "") => value.replace(/\D/g, "");

export const formatBrazilianMobile = (value = "") => {
  const digits = onlyDigits(value).slice(0, 11);

  if (digits.length <= 2) return digits.replace(/^(\d{1,2})/, "($1");
  if (digits.length <= 7) {
    return digits.replace(/^(\d{2})(\d+)/, "($1) $2");
  }

  return digits.replace(/^(\d{2})(\d{5})(\d{1,4}).*/, "($1) $2-$3");
};

export const normalizeEmail = (value = "") => value.trim().toLowerCase();
